export enum CheckupTagsContentStatus {
  LOADING,
  SUBMITTING,
  ERROR,
  SYNCED,
}
